import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {ExtensionRatingValue} from 'yougile-model'
import {ExtensionClient} from '@client/extension-client'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {getUppercaseExtName} from '@components/company-settings-popup/get-uppercase-ext-name'
import {MessageBox} from '@components/message-box'
import {globals} from '@extensions/globals-base'
import {ExtensionStore} from '../extensions-store'

export const handleExtensionRate = (
  extensionStore: ExtensionStore,
  rating: number
): Promise<void> => {
  const prevRating = extensionStore.currentUserRating
  extensionStore.rate(rating as ExtensionRatingValue)

  return ExtensionClient.rate(globals.getCompanyId(), extensionStore.id, rating)
    .then(res => {
      if (!res) {
        MessageBox.show(Lang.msg.extensions.ratings.failedOnChanged, 'danger')
      }
    })
    .catch(error => {
      extensionStore.rate(prevRating)
      MessageBox.show(Lang.msg.extensions.ratings.failedOnChanged, 'danger')
      logger.error('Failed while update rating', error)
    })
}

export const handleExtensionEnable = async (
  extensionStore: ExtensionStore
): Promise<void> => {
  return ExtensionClient.install(globals.getCompanyId(), extensionStore.id)
    .then(res => {
      if (!res) {
        MessageBox.show(Lang.msg.extensions.addError, 'danger')
      } else {
        MessageBox.show(Lang.msg.extensions.addSuccess, 'success')
        extensionStore.enable()

        void Tracking.send(
          `Extensions:TurnOn${getUppercaseExtName(
            extensionStore.id
          )}` as TrackingEvent
        )
      }
    })
    .catch(e => {
      const msg = e?.message || ''
      if (msg.includes('Error install: Limit reached')) {
        MessageBox.show(Lang.msg.extensions.extLimitError, 'danger')

        void Tracking.send(
          `Extensions:ErrorLimitReached${getUppercaseExtName(
            extensionStore.id
          )}` as TrackingEvent
        )
      } else {
        MessageBox.show(Lang.msg.extensions.addError, 'danger')
      }
    })
}

export const handleExtensionDisable = async (
  extensionStore: ExtensionStore
): Promise<void> => {
  return ExtensionClient.uninstall(globals.getCompanyId(), extensionStore.id)
    .then(res => {
      if (!res) {
        MessageBox.show(Lang.msg.extensions.removeError, 'danger')
      } else {
        extensionStore.disable()

        void Tracking.send(
          `Extensions:TurnOff${getUppercaseExtName(
            extensionStore.id
          )}` as TrackingEvent
        )
      }
    })
    .catch(() => {
      MessageBox.show(Lang.msg.extensions.removeError, 'danger')
    })
}
